import { OptionItem } from '../option.model';
import { ApplicationSpecificQuestions } from './custom-page.model';

export const question1: OptionItem[] = [
    {
        id: 1,
        title: 'palletizingItemsQuestion1',
        description: 'palletizingItemsQuestionDescription1'
    },
    {
        id: 2,
        title: 'palletizingItemsQuestion2',
        description: 'palletizingItemsQuestionDescription2'
    },
    {
        id: 3,
        title: 'palletizingItemsQuestion3',
        description: 'palletizingItemsQuestionDescription3'
    },
    {
        id: 4,
        title: 'palletizingItemsQuestion4',
        description: 'palletizingItemsQuestionDescription4'
    },
];

export const question2: OptionItem[] = [
    {
        id: 1,
        title: 'palletizingItemWeightQuestion1',
        description: 'palletizingItemWeightQuestionDescription1'
    },
    {
        id: 2,
        title: 'palletizingItemWeightQuestion2',
        description: 'palletizingItemWeightQuestionDescription2'
    },
    {
        id: 3,
        title: 'palletizingItemWeightQuestion3',
        description: 'palletizingItemWeightQuestionDescription3'
    },
];

export const question3: OptionItem[] = [
    {
        id: 1,
        title: 'palletizingProcessQuestion1',
        description: 'palletizingProcessQuestionDescription1',
        icon: 'speed_low_duotone'
    },
    {
        id: 2,
        title: 'palletizingProcessQuestion2',
        description: 'palletizingProcessQuestionDescription2',
        icon: 'speed_medium_duotone'
    },
    {
        id: 3,
        title: 'palletizingProcessQuestion3',
        description: 'palletizingProcessQuestionDescription3',
        icon: 'speed_high_duotone'
    },
    {
        id: 4,
        title: 'palletizingProcessQuestion4',
        description: 'palletizingProcessQuestionDescription4',
        icon: 'shuffle_up_duotone'
    },
];

export const question4: OptionItem[] = [
    {
        id: 1,
        title: 'palletizingSupportSetupQuestion1',
        description: 'palletizingSupportSetupQuestionDescription1',
        icon: 'thumbs_up_duotone'
    },
    {
        id: 2,
        title: 'palletizingSupportSetupQuestion2',
        description: 'palletizingSupportSetupQuestionDescription2',
        icon: 'headset_duotone'
    },
    {
        id: 3,
        title: 'palletizingSupportSetupQuestion3',
        description: 'palletizingSupportSetupQuestionDescription3',
        icon: 'user_duotone'
    },
    {
        id: 4,
        title: 'palletizingSupportSetupQuestion4',
        description: 'palletizingSupportSetupQuestionDescription4',
        icon: 'users_three_duotone'
    },
];

export const question5: OptionItem[] = [
    {
        id: 1,
        title: 'palletizingIntegrationQuestion1',
        description: 'palletizingIntegrationQuestionDescription1'
    },
    {
        id: 2,
        title: 'palletizingIntegrationQuestion2',
        description: 'palletizingIntegrationQuestionDescription2'
    },
    {
        id: 3,
        title: 'palletizingIntegrationQuestion3',
        description: 'palletizingIntegrationQuestionDescription3'
    },
    {
        id: 4,
        title: 'palletizingIntegrationQuestion4',
        description: 'palletizingIntegrationQuestionDescription4'
    },
];

export const palletizingQuestions: ApplicationSpecificQuestions = {
    question1,
    question2,
    question3,
    question4,
    question5
};
